interface AuthCallbackTokens {
  accessToken: string
  refreshToken: string
}

const AUTH_CALLBACK_NONCE_KEY = 'auth.callback.nonce'
const AUTH_CALLBACK_NONCE_PARAM = 'auth_callback_nonce'

export const createAuthCallbackSource = (): string => {
  const bytes = crypto.getRandomValues(new Uint8Array(32))
  const nonce = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
  sessionStorage.setItem(AUTH_CALLBACK_NONCE_KEY, nonce)
  const source = new URL(window.location.origin)
  source.searchParams.set(AUTH_CALLBACK_NONCE_PARAM, nonce)
  return source.toString()
}

let invalidAuthCallback = false

let pendingTokens: AuthCallbackTokens | null = (() => {
  if (typeof window === 'undefined') return null
  const params = new URLSearchParams(window.location.search)
  const accessToken = params.get('access_token')
  const refreshToken = params.get('refresh_token')
  if (!accessToken && !refreshToken) return null

  const expectedNonce = sessionStorage.getItem(AUTH_CALLBACK_NONCE_KEY)
  const callbackNonce = params.get(AUTH_CALLBACK_NONCE_PARAM)
  invalidAuthCallback = !accessToken || !refreshToken || !expectedNonce || callbackNonce !== expectedNonce
  sessionStorage.removeItem(AUTH_CALLBACK_NONCE_KEY)

  for (const key of ['access_token', 'refresh_token', 'email', 'name', 'user_id', AUTH_CALLBACK_NONCE_PARAM]) {
    params.delete(key)
  }
  const query = params.toString()
  window.history.replaceState(
    window.history.state,
    document.title,
    `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`
  )
  if (invalidAuthCallback || !accessToken || !refreshToken) return null
  return { accessToken, refreshToken }
})()

export const getPendingAuthCallbackTokens = (): AuthCallbackTokens | null => pendingTokens

export const consumeInvalidAuthCallback = (): boolean => {
  const invalid = invalidAuthCallback
  invalidAuthCallback = false
  return invalid
}

export const hasPendingAuthCallbackTokens = (): boolean => pendingTokens !== null

export const finishAuthCallback = (): void => {
  pendingTokens = null
  window.dispatchEvent(new Event('auth-callback-complete'))
}
